var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "reports",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 25,
    height: 25,
    fill: "#fff",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "line-chart",
    transform: "translate(4 5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M33,304.545v2.732a.305.305,0,0,0,.3.3h2.112a.305.305,0,0,0,.3-.3v-4.805L34.187,304A1.86,1.86,0,0,1,33,304.545Z",
    transform: "translate(-31.858 -293.269)",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M142,301.471v4.84a.305.305,0,0,0,.3.3h2.112a.305.305,0,0,0,.3-.3v-2.849a1.841,1.841,0,0,1-1.271-.54Z",
    transform: "translate(-137.084 -292.303)",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M251,276.033v3.15a.305.305,0,0,0,.3.3h2.112a.305.305,0,0,0,.3-.3v-5.813l-2.42,2.42A1.811,1.811,0,0,1,251,276.033Z",
    transform: "translate(-242.31 -265.176)",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M362.517,170.171,360,172.688v6.869a.305.305,0,0,0,.3.3h2.112a.305.305,0,0,0,.3-.3v-9.2c-.069-.059-.121-.111-.159-.145Z",
    transform: "translate(-347.537 -165.549)",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M16.708,36.834a.588.588,0,0,0-.447-.163h-.055c-.983.045-1.963.093-2.946.138a.636.636,0,0,0-.454.156.516.516,0,0,0-.107.159.509.509,0,0,0,.156.616l.246.249c.17.173.343.346.516.516L7.675,44.45,5.006,41.781a.848.848,0,0,0-1.2,0L.249,45.333a.848.848,0,0,0,0,1.2l.159.159a.848.848,0,0,0,1.2,0L4.4,43.9l2.669,2.669a.853.853,0,0,0,1.2,0l6.7-6.7.758.755a.574.574,0,0,0,.405.215.5.5,0,0,0,.242-.066.66.66,0,0,0,.145-.107.7.7,0,0,0,.183-.488c.028-.637.059-1.274.09-1.915l.045-.959A.6.6,0,0,0,16.708,36.834Z",
    transform: "translate(0 -36.671)",
    fill: "#545454"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.b2795b0d81c2d6ca733a362d1c73027c.svg";
export { ForwardRef as ReactComponent };